import { formatDate, formatDateAndTime } from 'helpers/formaters/formatDate';
import { useDomainConfig } from 'hooks/useDomainConfig';

export const useFormatDate = (): {
    formatDate: typeof formatDate;
    formatDateAndTime: typeof formatDateAndTime;
} => {
    const { defaultTimezone } = useDomainConfig();

    return {
        formatDate: (date) => formatDate(date, defaultTimezone),
        formatDateAndTime: (date) => formatDateAndTime(date, defaultTimezone),
    };
};
